import type { Variants } from '@amplitude/experiment-js-client'

export const EXPERIMENT_TREATMENT = 'treatment'

export const EXPERIMENTS = {
  ['web-3328']: 'web-my-progress-jbi-position',
} as const

export type ExperimentAssignment = {
  experimentKey: string
  key: string | undefined
  value: string | undefined
}

export function getExperiment(
  variants: Variants | null | undefined,
  experimentKey: string
): ExperimentAssignment {
  const variant = variants?.[experimentKey]
  return {
    experimentKey,
    key: variant?.key,
    value: variant?.value,
  }
}
